import { WhatsappInstance } from '../types';

type InstanceLike = Pick<WhatsappInstance, 'instance_name'> & {
    display_name?: string | null;
    users?: { name: string } | null;
};

// Nome exibido no CRM. O display_name é só um apelido interno: o instance_name
// continua sendo o identificador técnico usado na WuzAPI e nunca é alterado.
export function instanceLabel(instance: InstanceLike): string {
    return instance.display_name?.trim() || instance.users?.name || instance.instance_name;
}

// Vendedor só pode enviar pela instância vinculada a ele ou pela padrão da empresa;
// os demais cargos veem todas.
export function isRestrictedToOwnInstance(role?: string | null): boolean {
    return role?.toLowerCase().trim() === 'vendedor';
}

export function instancesAvailableTo<T extends Pick<WhatsappInstance, 'user_id' | 'is_default'>>(
    instances: T[],
    role: string | null | undefined,
    userId: string | null | undefined
): T[] {
    if (!isRestrictedToOwnInstance(role)) return instances;
    return instances.filter(inst => inst.is_default || (!!userId && inst.user_id === userId));
}
